<template>
  <div class="global-slideshow">
    <Swiper
      ref="slideshow"
      :options="swiperOptions"
      :auto-update="false"
      :delete-instance-on-destroy="false"
      :cleanup-styles-on-destroy="false"
      class="global-slideshow__swiper"
    >
      <SwiperSlide
        v-for="(slide, k) in slides"
        :key="getKey('global_slideshow', k)"
      >
        <component
          :is="slideComponent"
          class="global-slideshow__slide"
          :index="k"
          :slide="slide"
        />
      </SwiperSlide>
    </Swiper>
    <div class="global-slideshow__controls">
      <div class="global-slideshow__pagination"></div>
    </div>
  </div>
</template>

<script>
import {
  Swiper as SwiperClass,
  Mousewheel,
  Pagination,
} from 'swiper/js/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import BrowserMixin from '~/mixins/browser'

SwiperClass.use([Mousewheel, Pagination])
const { Swiper, SwiperSlide, directive } = getAwesomeSwiper(SwiperClass)

import CommonSlideImage from './CommonSlideImage'

// import SvgArrowslideshowLeft from '../svg/SvgArrowslLeft.vue'
// import SvgArrowslideshowRight from '../svg/SvgArrowslRight.vue'

export default {
  directives: {
    swiper: directive,
  },
  components: {
    Swiper,
    SwiperSlide,
    CommonSlideImage,
    // SvgArrowslideshowLeft,
    // SvgArrowslideshowRight,
  },
  mixins: [BrowserMixin],
  props: {
    slideComponent: String,
    slides: Array,
  },
  // mixins: [resize],
  data() {
    return {
      ready: false,
      slideshowTransition: 0,
      slideshowTranslate: 0,
      dragging: false,
      slideSize: 0,
    }
  },
  computed: {
    isTablet() {
      return window.innerWidth < 820
    },
    swiperOptions() {
      return {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        pagination: {
          el: '.global-slideshow__pagination',
          type: 'bullets',
          clickable: true,
        },
      }
    },
    swiper() {
      return this.$refs.slideshow.$swiper
    },
  },
  methods: {
    next() {
      this.swiper.slideNext()
    },
    prev() {
      this.swiper.slidePrev()
    },
  },
}
</script>


<style lang="scss">
@import 'swiper/css/swiper.css';
@import '~/styles/base';

.global-slideshow {
  position: relative;

  &__swiper {
    height: 100%;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    width: 100%;
    /* width: columns(5); */
    /* margin-left: columns(1.5); */
  }

  &__slide {
    /* padding: 0 var(--gutter) 0; */
  }

  &__controls {
    display: flex;
    margin-top: 20px;
  }

  &__pagination {
    margin: 0 auto;
    display: flex;
    gap: 5px;

    --swiper-pagination-color: var(--foreground);
  }

  &__control {
    display: inline-flex;
    /* margin-left: auto; */
    cursor: pointer;
    padding: 10px;

    svg {
      width: 30px;
    }
  }
}
</style>